/*=========================================================================================
  File Name: moduleResourceManagement.js
  Description: Resource Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleResourceManagementState.js'
import mutations from './moduleResourceManagementMutations.js'
import actions from './moduleResourceManagementActions.js'
import getters from './moduleResourceManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

